import type { ToastComponentProps } from './Toast';
import type { MessageOptions } from '../message';
import type { ToastKind } from './types.old';

export interface OldToastComponentProps extends Omit<ToastComponentProps, 'status'> {
  /** @deprecated status를 대신 사용해주세요. */
  kind?: ToastKind;
}

export function convertOldToastProps(props: OldToastComponentProps): ToastComponentProps {
  const { kind, ...restProps } = props;

  return {
    ...restProps,
    status: kind,
  };
}

export function convertOldToastOptions(
  props: MessageOptions<OldToastComponentProps>,
): MessageOptions<ToastComponentProps> {
  const { kind, ...restProps } = props;

  return {
    ...restProps,
    status: kind,
  };
}
